import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import settings from 'settings';
import { list, reset } from 'actions';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { Form } from 'antd';

const REDUCER_KEY = 'usersReassign';
const UNALLOCATED_USER = {
  id: -1,
  title: 'UNALLOCATED'
};

const mapStateToProps = state => ({
  users: state.api.usersReassign.data.results,
  inFlight: state.api.usersReassign.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadUsers(filters = []) {
    const sorted = [{
      id: 'last_name',
      desc: false
    }, {
      id: 'first_name',
      desc: false
    }];
    return dispatch(list(REDUCER_KEY, {
      page: 0,
      pageSize: settings.APP_CONFIG.dropListSize,
      filters,
      sorted
    }));
  },
  resetUsers() {
    return dispatch(reset(REDUCER_KEY));
  }
});

class ReassignActivitiesForm extends Component {
  constructor(props) {
    super(props);

    this.selectedUser = UNALLOCATED_USER;

    this.handleUserSearch = this.handleUserSearch.bind(this);
    this.handleUserSelectionChange = this.handleUserSelectionChange.bind(this);
  }

  componentDidMount() {
    const { loadUsers } = this.props;
    loadUsers();
  }

  componentWillUnmount() {
    const { resetUsers } = this.props;
    resetUsers();
  }

  handleUserSearch(searchText) {
    const { loadUsers } = this.props;
    const filter = [{
      id: 'name',
      value: searchText
    }];
    loadUsers(filter);
  }

  handleUserSelectionChange(selection) {
    const { users } = this.props;
    if (selection.key === -1) {
      this.selectedUser = UNALLOCATED_USER;
    }
    else {
      const user = users.find(u => u.id === selection.key);
      this.selectedUser = user;
    }
  }

  render() {
    const { form, users, inFlight } = this.props;

    const dropdownUsers = users.map(u => ({
      id: u.id,
      title: `${u.last_name}, ${u.first_name}`
    }));
    dropdownUsers.unshift(UNALLOCATED_USER);

    const { getFieldDecorator } = form;
    const layout = {
      inputLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 19 }
        }
      }
    };

    return (
      <div className="bhp-form">
        <Form>
          <Form.Item {...layout.inputLayout} label="Reassign to:">
            {getFieldDecorator('user', {
              initialValue: {
                key: UNALLOCATED_USER.id,
                label: UNALLOCATED_USER.title
              },
              rules: [{
                required: true,
                message: 'Please select a User.'
              }]
            })(
              <ExtendedSelect
                placeholder="Select User"
                fetching={inFlight}
                dataSource={dropdownUsers}
                optionKey={i => i.id}
                optionLabel={i => i.title}
                onSearch={this.handleUserSearch}
                onChange={this.handleUserSelectionChange}
                allowClear={false}
              />
            )}
          </Form.Item>
        </Form>
      </div>
    );
  }
}

ReassignActivitiesForm.propTypes = {
  // Redux Functions
  loadUsers: PropTypes.func.isRequired,
  resetUsers: PropTypes.func.isRequired,
  // Redux State
  users: PropTypes.array,
  inFlight: PropTypes.bool,
  // Ant form
  form: PropTypes.object.isRequired
};

ReassignActivitiesForm.defaultProps = {
  users: [],
  inFlight: false
};

const ReassignActivitiesWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ReassignActivitiesForm);

export default Form.create({})(ReassignActivitiesWrapper);
